import React from "react";
import {
  Box,
  Typography,
  Divider,
  Link,
  Card,
  CardContent,
} from "@mui/material";
import { BackLink } from "@/Components/Buttons/Link";

const InvoiceSummaryCard = ({
  totalInvoiceValue,
  totalProductValue,
  invoiceNumber,
  toi,
  currentInvoiceValue,
  currentProductValue,
  onCalculateClick,
  onUpdateIGSTClick,
  currency
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        borderColor: "var(--green-50)",
        borderRadius: "8px",
        maxWidth: "95%",
        mt:2, 
        mx: 2,
        backgroundColor: "var(--green-20)",
        
      }}
    >
      <CardContent sx={{ marginBottom: 0 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          {/* Total Section */}
          <Box sx={{ width: "28%" }}>
            <Typography variant="bodySmallStrong">Total</Typography>
            <Box
              sx={{
                display: "flex",
                gap: 5,
                mt: 3,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography variant="bodySmall" color="var(--green-700)">
                  Invoice Value:
                </Typography>
                <Typography variant="bodySmallStrong">
                  {totalInvoiceValue} {currency}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {" "}
                <Typography variant="bodySmall" color="var(--green-700)">
                  Product Value:
                </Typography>
                <Typography variant="bodySmallStrong">
                  {totalProductValue} {currency}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              position: "relative",
              width: "1px",
              display: "flex",
              alignItems: "center",
              mx: 3,
            }}
          >
            <Divider
              orientation="vertical"
              sx={{
                position: "absolute",
                height: "325px", // taller line
                left: 0,
                top: "50%",
                transform: "translateY(-50%)",
                borderColor: "var(--green-50)",
              }}
            />
          </Box>
          {/* Current Invoice Details */}
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="bodySmallStrong">
                Current Invoice Details
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 5,
                  // justifyContent: "space-between",
                }}
              >
                <BackLink
                  label="Calculate Value as Per TOI"
                  variant="bodySmall"
                  onClick={onCalculateClick}
                  sx={{ textDecoration: "none" }}
                >
                  Calculate Value as per TOI
                </BackLink>
                <BackLink
                  label="Update IGST Values"
                  variant="bodySmall"
                  mb="2"
                  onClick={onUpdateIGSTClick}
                  sx={{ color: "var( --link-blue)" }}
                ></BackLink>
              </Box>
            </Box>
            <Box sx={{ display: "flex", gap: 5, mt: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {" "}
                <Typography variant="bodySmall" color="var(--green-700)">
                  Invoice Number:
                </Typography>
                <Typography variant="bodySmallStrong">
                  {invoiceNumber}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {" "}
                <Typography variant="bodySmall" color="var(--green-700)">
                  TOI:
                </Typography>
                <Typography variant="bodySmallStrong">{toi}</Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {" "}
                <Typography variant="bodySmall" color="var(--green-700)">
                  Invoice Value:
                </Typography>
                <Typography variant="bodySmallStrong">
                  {currentInvoiceValue}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {" "}
                <Typography variant="bodySmall" color="var(--green-700)">
                  Product Value:
                </Typography>
                <Typography variant="bodySmallStrong">
                  {currentProductValue}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default InvoiceSummaryCard;
